const MEDAL_TEXT_COLOR = "#09044a";
const MEDAL_FONT_FAMILY = '"Exo 2", sans-serif';
const MEDAL_CENTER_X = 1200;
const MEDAL_TEXT_MAX_WIDTH = 560;
const MEDAL_EXPORT_WIDTH = 1200;

const SEASON_TEXT = { baseline: 1821, fontSize: 105, fontWeight: 500 };
const YEAR_TEXT = { baseline: 2002, fontSize: 177, fontWeight: 700 };

type TMedalText = typeof SEASON_TEXT;

function loadImage(src: string): Promise<HTMLImageElement> {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.crossOrigin = "anonymous";
    image.onload = () => resolve(image);
    image.onerror = reject;
    image.src = src;
  });
}

function drawCenteredText(
  context: CanvasRenderingContext2D,
  text: string,
  { baseline, fontSize, fontWeight }: TMedalText
) {
  let size = fontSize;
  context.font = `${fontWeight} ${size}px ${MEDAL_FONT_FAMILY}`;

  while (context.measureText(text).width > MEDAL_TEXT_MAX_WIDTH && size > 40) {
    size -= 2;
    context.font = `${fontWeight} ${size}px ${MEDAL_FONT_FAMILY}`;
  }

  context.fillText(text, MEDAL_CENTER_X, baseline);
}

export async function renderMedalImage(
  src: string,
  { season, year }: { season: string; year: number }
): Promise<string> {
  const [image] = await Promise.all([
    loadImage(src),
    document.fonts.load(
      `${SEASON_TEXT.fontWeight} ${SEASON_TEXT.fontSize}px ${MEDAL_FONT_FAMILY}`
    ),
    document.fonts.load(
      `${YEAR_TEXT.fontWeight} ${YEAR_TEXT.fontSize}px ${MEDAL_FONT_FAMILY}`
    ),
  ]);

  const scale = MEDAL_EXPORT_WIDTH / image.naturalWidth;
  const canvas = document.createElement("canvas");
  canvas.width = Math.round(image.naturalWidth * scale);
  canvas.height = Math.round(image.naturalHeight * scale);

  const context = canvas.getContext("2d");
  if (!context) throw new Error("Season and year unavailable");

  context.scale(scale, scale);
  context.imageSmoothingQuality = "high";
  context.drawImage(image, 0, 0);
  context.fillStyle = MEDAL_TEXT_COLOR;
  context.textAlign = "center";
  context.textBaseline = "alphabetic";

  drawCenteredText(context, season, SEASON_TEXT);
  drawCenteredText(context, String(year), YEAR_TEXT);

  return canvas.toDataURL("image/png");
}
